import { Buffer } from 'buffer'
import process from 'process'
import PropTypes from 'prop-types'

if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer
}

if (typeof window !== 'undefined' && !window.process) {
  window.process = process
}

const moduleMap = {
  'prop-types': PropTypes,
  react: require('react'),
  'react-dom': require('react-dom')
}

window.require = id => {
  if (moduleMap[id]) {
    return moduleMap[id]
  }
  return {}
}
